module.exports = __webpack_public_path__ + "static/img/404.272f8b21.png";